import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { withContent, BackgroundImage } from '@bubbletea/core';
import { IStoreState } from '../../../types/store';
import { IContent } from '../../../types';

import { SubscribeToContainer, SubscribeToTitle } from './styles';
import SubscriptionButtons from '../../UI/Button/SubscriptionButtons';
import sendEvent from '../../../utils/sendEvent';

interface ISubscribeToProps {
  context: IContent;
}

const SubscribeTo = ({ context }: ISubscribeToProps) => {
  const [impressionEventRegistered, setImpressionEventRegistered] = useState(false);
  const contentSelector = useSelector((state: IStoreState) => ({
    analyticsLoaded: state.app.analyticsLoaded,
    subscriptions: state.user.user.subscriptions,
  }));
  const { analyticsLoaded, subscriptions } = contentSelector;
  const { subscribe } = context.googlesheet;
  const { title } = subscribe;

  useEffect(() => {
    const impressionEventDetails = {
      location: 'promo banner',
      locationDetail: subscriptions.length && title.subscriber ? 'start learning' : 'subscribe to rocksmith plus',
      category: 'scroll',
      locationPosition: process.env['REACT_APP_PAGE_TYPE'] === 'subscriber' ? 8 : 9,
      action: 'visible',
    };
    if (analyticsLoaded && impressionEventRegistered) {
      setImpressionEventRegistered(false);
      sendEvent(impressionEventDetails, 'impressionevent');
    }
  }, [impressionEventRegistered, analyticsLoaded]);

  const eventDetails = {
    location: 'promo banner',
    locationPosition: process.env['REACT_APP_PAGE_TYPE'] === 'subscriber' ? 8 : 9,
  };

  const subscriptionSuspended = subscriptions.some((subscription) => subscription.status === 'suspended');

  return !subscriptionSuspended ? (
    <SubscribeToContainer
      id={'subscribe'}
      whileInView={'sendevent'}
      onAnimationStart={() => setImpressionEventRegistered(true)}
      viewport={{ once: true }}
    >
      <BackgroundImage imageNames={['bg-subscribe.svg']} classNames={['bg-subscribe']} dynamic />
      <div className="section-wrapper">
        {subscriptions.length && title.subscriber ? (
          <SubscribeToTitle>{title.subscriber}</SubscribeToTitle>
        ) : !subscriptions.length && title.nonSubscriber ? (
          <SubscribeToTitle>{title.nonSubscriber}</SubscribeToTitle>
        ) : null}
        <SubscriptionButtons tracking={eventDetails} onlyPlayNow />
      </div>
    </SubscribeToContainer>
  ) : null;
};

export default withContent(SubscribeTo);
